import logo from "./components/images/Inspect it-Logo.png";
import "./App.css";
import Inspect_it_App from "./components/apk/Inspect-it.apk";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>Click the link below to start downloading the Inspect-it App</p>
        <a
          className="App-link"
          href={Inspect_it_App}
          target="_blank"
          download
          rel="noopener noreferrer"
        >
          Download Now
        </a>
      </header>
    </div>
  );
}

export default App;
